import { render, staticRenderFns } from "./JgBespokeMines.vue?vue&type=template&id=07057e36&scoped=true&"
import script from "./JgBespokeMines.vue?vue&type=script&lang=ts&"
export * from "./JgBespokeMines.vue?vue&type=script&lang=ts&"
import style0 from "./JgBespokeMines.vue?vue&type=style&index=0&id=07057e36&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07057e36",
  null
  
)

export default component.exports